(ns minorodata.dag.model
  (:require [mold.core :as m :refer-macros [defmodel]]
            [minorodata.transform.model :refer [transform]]))


(defmodel edge
  {:from {::m/type     ::m/ref
          ::m/ref-type transform
          ::m/doc      "Start of the edge"}
   :to   {::m/type     ::m/ref
          ::m/ref-type transform
          ::m/doc      "End of the edge"}})


(defmodel dag
  {:nodes         {::m/type        ::m/ref
                   ::m/cardinality ::m/many
                   ::m/ref-type    transform
                   ::m/doc         "Links to transforms"}
   :edges         {::m/type         ::m/ref
                   ::m/cardinality  ::m/many
                   ::m/is-component ::m/component
                   ::m/ref-type     edge
                   ::m/doc          "DAG edge"}
   :loaded?       [::m/bool "Is DAG ready"]
   :error-message [::m/string ::m/nilable "Any dag error that should be displayed to the user"]
   :root-node     [::m/string ::m/nilable "Selected root node"]
   :view-type     [::m/keyword "Upstream, Downstream or Both"]}
  {:singleton true})
